var exports = {
  "OH": "EditHistoryDialogContainer__ZFMIiB",
  "Vm": "editHistoryContentScrollable__8B-zm4",
  "Fn": "contentViewerContainer__c9wp-y",
  "j0": "mutedInfoText__znzahi",
  "BV": "loadingSkeletonContainer__eYJoHI",
};

module.exports = exports;
